'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipWrapperStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  theme: _propTypes2.default.object
};

var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var zIndex = theme.reactackle.components.tooltip.zIndex;


  return '\n    z-index: ' + zIndex + ';\n  ';
};

var TooltipWrapperStyled = exports.TooltipWrapperStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TooltipWrapperStyled'
})(['position:fixed;', ';'], baseProps);

TooltipWrapperStyled.propTypes = propTypes;
TooltipWrapperStyled.displayName = 'TooltipWrapperStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tooltip/dist/styles/TooltipWrapperStyled.js
// module id = 237
// module chunks = 0